import { render, staticRenderFns } from "./preset-search-coverage.vue?vue&type=template&id=2638dec4&scoped=true&"
import script from "./preset-search-coverage.vue?vue&type=script&lang=js&"
export * from "./preset-search-coverage.vue?vue&type=script&lang=js&"
import style0 from "./preset-search-coverage.vue?vue&type=style&index=0&id=2638dec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638dec4",
  null
  
)

export default component.exports